import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/layout/Header";
import Hero from "../../components/accomodation/hero/Hero";
import { IMAGES } from "../../data/images";
import Working from "../../components/accomodation/working/Working";
import Faq from "../../components/accomodation/faq/Faq";
import Footer from "../../components/layout/Footer";
import Help1 from "../../components/resume/Help1";
import Help2 from "../../components/resume/Help2";
import { FAQS } from "../../data/faqs";

const stepsData = [
  {
    heading: "Fill up the form",
    description:
      "Our expert will call you to understand your needs and present an attractive SOP quotation.",
  },
  {
    heading: "Make the payment",
    description:
      "Once you accept the quotation, pay securely online through our checkout.",
  },
  {
    heading: "We write your SOP",
    description:
      "Our expert writer drafts your SOP and sends it in PDF format for your review.",
  },
  {
    heading: "Receive Final SOP",
    description:
      "Upon your approval (with up to 3 free revisions), we deliver your final SOP.",
  },
];

function Resume() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <Hero
        img={IMAGES.resumeWriting}
        heading="Expert SOP & Resume Writing"
        description="Professional application documents crafted by experts — starting at ₹3,999"
      />
      <Help1 />
      <Working data={stepsData} />
      <Help2 />
      <Faq data={FAQS.resume} />
      <div className="text-center py-8">
        <button
          onClick={() => navigate("/pricing")}
          className="bg-blue-600 text-white py-3 px-8 rounded-lg hover:bg-blue-700 font-semibold"
        >
          Order SOP Writing — ₹3,999
        </button>
      </div>
      <Footer />
    </>
  );
}

export default Resume;
